import { useState } from 'react';
import { Icon } from './ui';

export function CopyIcon({ value, label = 'Salin' }: { value: string; label?: string }) {
  const [done, setDone] = useState(false);
  return (
    <button
      type="button"
      className={done ? 'bl-copy done' : 'bl-copy'}
      title={done ? 'Tersalin' : label}
      aria-label={label}
      onClick={async (event) => {
        event.stopPropagation();
        try {
          await navigator.clipboard.writeText(value);
          setDone(true);
          setTimeout(() => setDone(false), 1400);
        } catch {
          setDone(false);
        }
      }}
    >
      <Icon name={done ? 'check' : 'copy'} size={14} />
    </button>
  );
}
